import { render, staticRenderFns } from "./ServicesPage.vue?vue&type=template&id=37c10451"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"
import style0 from "./ServicesPage.vue?vue&type=style&index=0&id=37c10451&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports